// import { createSlice } from '@reduxjs/toolkit'

// const initialState = {
//   login: false,
// }

// export const userSlice = createSlice({
//   name: 'user',
//   initialState,
//   reducers: { 
//     isLoggedIn: (state, action) => {
//       state.login = action.payload
//       // localStorage.setItem('login',action.payload)
//     },
//     logOut: (state, action) => {
//       state.login = false
//     },
//   }, 
// })

// // Action creators are generated for each case reducer function
// export const { isLoggedIn ,logOut} = userSlice.actions

// export default userSlice.reducer

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  login: false,
  name: '',
  roleId:0,
  screens:[],
  images:{}
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    isLoggedIn: (state, action) => {
      state.login = true;
      state.roleId=action.payload.roleId
      state.name = action.payload.name; // Save name from payload
      // localStorage.setItem('login', true);
      // localStorage.setItem('name', action.payload.name);
    },
    logOut: (state) => {
      state.login = false;
      state.roleId=0,
      state.name = ''; // Clear the name on logout
      // localStorage.removeItem('login');
      // localStorage.removeItem('name');
    },
    Userscreen:(state,action)=>{
      state.screens=action.payload;

    },
    ImageSlice:(state,action)=>{
      state.images=action.payload;

    }
  },
});

export const { isLoggedIn, logOut,Userscreen,ImageSlice } = userSlice.actions;

export default userSlice.reducer;
